module.exports = __webpack_public_path__ + "f230f14ad9184fc6b43250731cd76615.svg";